import type { ReactNode } from "react";
import posthog from "./posthog-browser";

export const PostHogProvider = ({
  children,
}: {
  client?: unknown;
  children?: ReactNode;
}) => <>{children}</>;

export const usePostHog = () => posthog;
